import React, { useEffect, useState } from 'react'
import { get_agent_latest_version } from '../../../functions'

function KubernetesConfigurationsOverview({connector, clusterStatus}) {
    
    const [help, setHelp] = useState(false)
    // const [agentVersion, setAgentVersion] = useState("latest")
    const kubectlCommand = 
        `helm repo add overseas https://overseas-org.github.io/helm-charts/ \n
helm repo update\n
helm install overseas-agent overseas/overseas-kubernetes-agent --set=agent_id=cluster-${connector.connector_id}`

    // useEffect(()=>{
    // const update_agent_version = async () => {
    //   const version = await get_agent_latest_version()
    //   setAgentVersion(version)
//     }
//     update_agent_version()
//   }, [])

    return (
        <div className='overview'>
            <label className='name'>{connector.name}</label>
            <div className='status'>
                <div className={`status-light ${clusterStatus ? 'online': 'offline'}`}/>
                <label>{`${clusterStatus ? 'online': 'offline'}`}</label>
                {!clusterStatus && <button onClick={()=>setHelp(!help)} className='help-button'>?</button>}
            </div>
            {
                (!clusterStatus && help) && <div className='help-box'>
                    <button className='copy-icon' onClick={async () => {
                            if (navigator.clipboard?.writeText) {
                            try {
                                await navigator.clipboard.writeText(kubectlCommand);
                            } catch (err) {
                                console.error("Clipboard write failed", err);
                            }
                            } else {
                            console.warn("Clipboard API not available");
                            }
                        }}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="20px"><path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"/></svg>
                    </button>
                    <label>run in kubernetes:</label>
                    <code><pre>{kubectlCommand}</pre></code>
                </div>
            }
        </div> 
    )
}

export default KubernetesConfigurationsOverview